/**
 * Lookup map for all 50 US states with their most populous cities and coordinates
 * 
 * This is used when a user searches by state name only, we'll direct them
 * to the most populous city in that state
 */
const STATE_LARGEST_CITIES = {
  "alabama": { city: "Birmingham", state: "AL", lat: 33.5186, lng: -86.8104 },
  "alaska": { city: "Anchorage", state: "AK", lat: 61.2181, lng: -149.9003 },
  "arizona": { city: "Phoenix", state: "AZ", lat: 33.4484, lng: -112.0740 },
  "arkansas": { city: "Little Rock", state: "AR", lat: 34.7465, lng: -92.2896 },
  "california": { city: "Los Angeles", state: "CA", lat: 34.0522, lng: -118.2437 },
  "colorado": { city: "Denver", state: "CO", lat: 39.7392, lng: -104.9903 },
  "connecticut": { city: "Bridgeport", state: "CT", lat: 41.1792, lng: -73.1894 },
  "delaware": { city: "Wilmington", state: "DE", lat: 39.7391, lng: -75.5398 },
  "florida": { city: "Jacksonville", state: "FL", lat: 30.3322, lng: -81.6557 },
  "georgia": { city: "Atlanta", state: "GA", lat: 33.7490, lng: -84.3880 },
  "hawaii": { city: "Honolulu", state: "HI", lat: 21.3069, lng: -157.8583 },
  "idaho": { city: "Boise", state: "ID", lat: 43.6187, lng: -116.2146 },
  "illinois": { city: "Chicago", state: "IL", lat: 41.8781, lng: -87.6298 },
  "indiana": { city: "Indianapolis", state: "IN", lat: 39.7684, lng: -86.1581 },
  "iowa": { city: "Des Moines", state: "IA", lat: 41.5868, lng: -93.6250 },
  "kansas": { city: "Wichita", state: "KS", lat: 37.6872, lng: -97.3301 },
  "kentucky": { city: "Louisville", state: "KY", lat: 38.2527, lng: -85.7585 },
  "louisiana": { city: "New Orleans", state: "LA", lat: 29.9511, lng: -90.0715 },
  "maine": { city: "Portland", state: "ME", lat: 43.6591, lng: -70.2568 },
  "maryland": { city: "Baltimore", state: "MD", lat: 39.2904, lng: -76.6122 },
  "massachusetts": { city: "Boston", state: "MA", lat: 42.3601, lng: -71.0589 },
  "michigan": { city: "Detroit", state: "MI", lat: 42.3314, lng: -83.0458 },
  "minnesota": { city: "Minneapolis", state: "MN", lat: 44.9778, lng: -93.2650 },
  "mississippi": { city: "Jackson", state: "MS", lat: 32.2988, lng: -90.1848 },
  "missouri": { city: "Kansas City", state: "MO", lat: 39.0997, lng: -94.5786 },
  "montana": { city: "Billings", state: "MT", lat: 45.7833, lng: -108.5007 },
  "nebraska": { city: "Omaha", state: "NE", lat: 41.2565, lng: -95.9345 },
  "nevada": { city: "Las Vegas", state: "NV", lat: 36.1699, lng: -115.1398 },
  "new hampshire": { city: "Manchester", state: "NH", lat: 42.9956, lng: -71.4548 },
  "new jersey": { city: "Newark", state: "NJ", lat: 40.7357, lng: -74.1724 },
  "new mexico": { city: "Albuquerque", state: "NM", lat: 35.0844, lng: -106.6504 },
  "new york": { city: "New York", state: "NY", lat: 40.7128, lng: -74.0060 },
  "north carolina": { city: "Charlotte", state: "NC", lat: 35.2271, lng: -80.8431 },
  "north dakota": { city: "Fargo", state: "ND", lat: 46.8772, lng: -96.7898 },
  "ohio": { city: "Columbus", state: "OH", lat: 39.9612, lng: -82.9988 },
  "oklahoma": { city: "Oklahoma City", state: "OK", lat: 35.4676, lng: -97.5164 },
  "oregon": { city: "Portland", state: "OR", lat: 45.5051, lng: -122.6750 },
  "pennsylvania": { city: "Philadelphia", state: "PA", lat: 39.9526, lng: -75.1652 },
  "rhode island": { city: "Providence", state: "RI", lat: 41.8240, lng: -71.4128 },
  "south carolina": { city: "Charleston", state: "SC", lat: 32.7765, lng: -79.9311 },
  "south dakota": { city: "Sioux Falls", state: "SD", lat: 43.5446, lng: -96.7311 },
  "tennessee": { city: "Nashville", state: "TN", lat: 36.1627, lng: -86.7816 },
  "texas": { city: "Houston", state: "TX", lat: 29.7604, lng: -95.3698 },
  "utah": { city: "Salt Lake City", state: "UT", lat: 40.7608, lng: -111.8910 },
  "vermont": { city: "Burlington", state: "VT", lat: 44.4759, lng: -73.2121 },
  "virginia": { city: "Virginia Beach", state: "VA", lat: 36.8529, lng: -75.9780 },
  "washington": { city: "Seattle", state: "WA", lat: 47.6062, lng: -122.3321 },
  "west virginia": { city: "Charleston", state: "WV", lat: 38.3498, lng: -81.6326 },
  "wisconsin": { city: "Milwaukee", state: "WI", lat: 43.0389, lng: -87.9065 },
  "wyoming": { city: "Cheyenne", state: "WY", lat: 41.1400, lng: -104.8202 },
  
  // State abbreviations mapped to the same data for convenience
  "al": { city: "Birmingham", state: "AL", lat: 33.5186, lng: -86.8104 },
  "ak": { city: "Anchorage", state: "AK", lat: 61.2181, lng: -149.9003 },
  "az": { city: "Phoenix", state: "AZ", lat: 33.4484, lng: -112.0740 },
  "ar": { city: "Little Rock", state: "AR", lat: 34.7465, lng: -92.2896 },
  "ca": { city: "Los Angeles", state: "CA", lat: 34.0522, lng: -118.2437 },
  "co": { city: "Denver", state: "CO", lat: 39.7392, lng: -104.9903 },
  "ct": { city: "Bridgeport", state: "CT", lat: 41.1792, lng: -73.1894 },
  "de": { city: "Wilmington", state: "DE", lat: 39.7391, lng: -75.5398 },
  "fl": { city: "Jacksonville", state: "FL", lat: 30.3322, lng: -81.6557 },
  "ga": { city: "Atlanta", state: "GA", lat: 33.7490, lng: -84.3880 },
  "hi": { city: "Honolulu", state: "HI", lat: 21.3069, lng: -157.8583 },
  "id": { city: "Boise", state: "ID", lat: 43.6187, lng: -116.2146 },
  "il": { city: "Chicago", state: "IL", lat: 41.8781, lng: -87.6298 },
  "in": { city: "Indianapolis", state: "IN", lat: 39.7684, lng: -86.1581 },
  "ia": { city: "Des Moines", state: "IA", lat: 41.5868, lng: -93.6250 },
  "ks": { city: "Wichita", state: "KS", lat: 37.6872, lng: -97.3301 },
  "ky": { city: "Louisville", state: "KY", lat: 38.2527, lng: -85.7585 },
  "la": { city: "New Orleans", state: "LA", lat: 29.9511, lng: -90.0715 },
  "me": { city: "Portland", state: "ME", lat: 43.6591, lng: -70.2568 },
  "md": { city: "Baltimore", state: "MD", lat: 39.2904, lng: -76.6122 },
  "ma": { city: "Boston", state: "MA", lat: 42.3601, lng: -71.0589 },
  "mi": { city: "Detroit", state: "MI", lat: 42.3314, lng: -83.0458 },
  "mn": { city: "Minneapolis", state: "MN", lat: 44.9778, lng: -93.2650 },
  "ms": { city: "Jackson", state: "MS", lat: 32.2988, lng: -90.1848 },
  "mo": { city: "Kansas City", state: "MO", lat: 39.0997, lng: -94.5786 },
  "mt": { city: "Billings", state: "MT", lat: 45.7833, lng: -108.5007 },
  "ne": { city: "Omaha", state: "NE", lat: 41.2565, lng: -95.9345 },
  "nv": { city: "Las Vegas", state: "NV", lat: 36.1699, lng: -115.1398 },
  "nh": { city: "Manchester", state: "NH", lat: 42.9956, lng: -71.4548 },
  "nj": { city: "Newark", state: "NJ", lat: 40.7357, lng: -74.1724 },
  "nm": { city: "Albuquerque", state: "NM", lat: 35.0844, lng: -106.6504 },
  "ny": { city: "New York", state: "NY", lat: 40.7128, lng: -74.0060 },
  "nc": { city: "Charlotte", state: "NC", lat: 35.2271, lng: -80.8431 },
  "nd": { city: "Fargo", state: "ND", lat: 46.8772, lng: -96.7898 },
  "oh": { city: "Columbus", state: "OH", lat: 39.9612, lng: -82.9988 },
  "ok": { city: "Oklahoma City", state: "OK", lat: 35.4676, lng: -97.5164 },
  "or": { city: "Portland", state: "OR", lat: 45.5051, lng: -122.6750 },
  "pa": { city: "Philadelphia", state: "PA", lat: 39.9526, lng: -75.1652 },
  "ri": { city: "Providence", state: "RI", lat: 41.8240, lng: -71.4128 },
  "sc": { city: "Charleston", state: "SC", lat: 32.7765, lng: -79.9311 },
  "sd": { city: "Sioux Falls", state: "SD", lat: 43.5446, lng: -96.7311 },
  "tn": { city: "Nashville", state: "TN", lat: 36.1627, lng: -86.7816 },
  "tx": { city: "Houston", state: "TX", lat: 29.7604, lng: -95.3698 },
  "ut": { city: "Salt Lake City", state: "UT", lat: 40.7608, lng: -111.8910 },
  "vt": { city: "Burlington", state: "VT", lat: 44.4759, lng: -73.2121 },
  "va": { city: "Virginia Beach", state: "VA", lat: 36.8529, lng: -75.9780 },
  "wa": { city: "Seattle", state: "WA", lat: 47.6062, lng: -122.3321 },
  "wv": { city: "Charleston", state: "WV", lat: 38.3498, lng: -81.6326 },
  "wi": { city: "Milwaukee", state: "WI", lat: 43.0389, lng: -87.9065 },
  "wy": { city: "Cheyenne", state: "WY", lat: 41.1400, lng: -104.8202 }
};

/**
 * Check if the input is a US state name or abbreviation
 * @param {string} input - The input to check
 * @returns {object|null} - The state data or null if not a state
 */
export function isUSState(input) {
  if (!input) return null;
  
  const normalized = input.trim().toLowerCase();
  return STATE_LARGEST_CITIES[normalized] || null;
}

/**
 * Get the most populous city for a state
 * @param {string} stateNameOrAbbr - State name or abbreviation
 * @returns {object|null} - City data or null if state not found
 */
export function getMostPopulousCity(stateNameOrAbbr) {
  return isUSState(stateNameOrAbbr);
}

export default STATE_LARGEST_CITIES; 